import React from 'react';
import { Link } from 'react-router-dom';
import { Translate } from 'react-redux-i18n';

import ROUTES from '../data/routes';

const NotFoundPage = () => (
  <div>
    <h3><Translate value="pageNotFound" /></h3>
    <p><Link to={ROUTES.HOME}><Translate value="returnHome" /></Link></p>
  </div>
);

export default NotFoundPage;
